import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import Icon from '@common/images/incorrect-icon.svg';
import {Tooltip} from '@learningblocks/shared-components';

const TYPE = 'FAIL';

export function IconIncorrect(props) {
  return (
    <Tooltip show={props.show} title={props.message} type={TYPE}>
      <Image className={props.className} src={Icon} alt={props.message} />
    </Tooltip>
  );
}

IconIncorrect.propTypes = {
  /**
   * Message to display on ErrorTooltip
   */
  message: PropTypes.string,
  /**
   * ClassName for Icon
   */
  className: PropTypes.string,
};

IconIncorrect.defaultProps = {
  message: '',
};
